/**
 * 전역 Alert 상태 관리 Store (Zustand)
 * - Alert 컴포넌트의 표시 상태를 전역 관리
 * - apiClient 등 비-React 모듈에서도 Alert를 표시할 수 있도록 함
 */
import { create } from 'zustand';

/**
 * useAlertStore
 * - isOpen: Alert 표시 여부
 * - message: Alert 메시지
 * - onCloseCallback: Alert 닫을 때 실행할 콜백 함수
 * - disableOverlayClick: 오버레이 클릭으로 닫기 방지 (인증 관련 Alert 등)
 * - showAlert: Alert 표시 함수 (message, onCloseCallback, disableOverlayClick)
 * - closeAlert: Alert 닫기 함수
 */
function createAlertStore(set) {
  return {
    isOpen: false,
    message: '',
    onCloseCallback: null,
    disableOverlayClick: false,

    // Alert 표시
    // @param {string} message - Alert 메시지
    // @param {Function} onCloseCallback - Alert 닫을 때 실행할 콜백 함수 (선택)
    // @param {boolean} disableOverlayClick - 오버레이 클릭으로 닫기 방지 (선택, 기본값: false)
    showAlert(message, onCloseCallback = null, disableOverlayClick = false) {
      set({
        isOpen: true,
        message,
        onCloseCallback,
        disableOverlayClick,
      });
    },

    // Alert 닫기
    closeAlert() {
      set(function (state) {
        const callback = state.onCloseCallback;

        // 저장된 콜백이 있으면 실행
        if (callback && typeof callback === 'function') {
          // 비동기로 실행하여 상태 업데이트 후 콜백 실행
          setTimeout(function () {
            callback();
          }, 0);
        }

        return {
          isOpen: false,
          message: '',
          onCloseCallback: null,
          disableOverlayClick: false,
        };
      });
    },
  };
}

const useAlertStore = create(createAlertStore);

export default useAlertStore;
